module.exports = __webpack_public_path__ + "static/media/insturctor5.355613c7.png";